import React, { useEffect } from 'react'
import DashboardLayout from './DashboardLayout'
import './style.css'
import { useDispatch, useSelector } from 'react-redux';
import { getCorporatesStatsAPI } from '../../../redux/slices/dashboardStatsSlice';

const Dashboard = () => {

    const dispatch = useDispatch();
    const corporatesStats = useSelector((state) => state?.dashboardStatsSlice?.corporatesStats);
    const user = useSelector(state => state?.AuthSlice?.user)

    const fetchCorporates = async () => {
        try {
            await dispatch(getCorporatesStatsAPI(user?.id));
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCorporates();
    }, []);


    return (
        <>
            <DashboardLayout>
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                            <div className="dashboard-icon-couter">
                                <div className="dashboard-icon-image">
                                    <img src="/images/number-of-employe.png" alt="" />
                                </div>
                                <p>Number of Employees</p>
                                <h1>{corporatesStats?.total_employees}</h1>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                            <div className="dashboard-icon-couter">
                                <div className="dashboard-icon-image">
                                    <img src="/images/number-of-services.png" alt="" />
                                </div>
                                <p>Number of Services</p>
                                <h1>{corporatesStats?.total_services}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    )
}

export default Dashboard